<template>
  <modal
    name="invite-more-permit-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="565"
    height="auto"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Invite More</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body" style="height: 390px">
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2"> Group </label
            ><input
              type="text"
              disabled
              readonly
              placeholder="Enter a group name"
              class="textInputField"
              v-model="invitation_name"
            />
          </div>
          <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div class="mb-2">
                <label
                  :class="[
                    'txt--ss cursor-pointer mb-0',
                    emailUploadProcess === 'email'
                      ? 'txt--primary'
                      : 'txt--off-white',
                  ]"
                  @click="changeFilter('email')"
                >
                  Email Address(s)
                </label>

                <p
                  class="txt--xs txt--off-white"
                  v-if="emailUploadProcess === 'email'"
                >
                  separate emails by pressing enter<!-- a space or comma -->
                </p>
              </div>
              <p
                :class="[
                  'txt--ss  cursor-pointer mb-2',
                  emailUploadProcess === 'csv'
                    ? 'txt--primary'
                    : 'txt--off-white',
                ]"
                @click="changeFilter('csv')"
              >
                Upload CSV
              </p>
            </div>

            <div class="" v-if="emailUploadProcess === 'email'">
              <!--  <input
                type="text"
                placeholder="Enter email address(s)"
                class="textInputField"
                v-model="emailInvitation"
              /> -->
              <vue-tags-input
                v-model="emailtag"
                :tags="emailtags"
                @tags-changed="(newTags) => (emailtags = newTags)"
                :validation="validation"
                placeholder="Enter email address(s)"
              />
            </div>
            <div
              class="monthlySubsForm py-2"
              v-if="emailUploadProcess === 'csv'"
            >
              <div class="monthlySubsForm__upload mb-1">
                <ButtonWithSpinner
                  class="button button--primary button--sm mr-3 mb-2"
                  :loading="upload_button.loading"
                  :success="upload_button.success"
                  :disabled="upload_button.disabled"
                  @click="$refs.csvFileInput.click()"
                >
                  Upload
                </ButtonWithSpinner>

                <label
                  class="monthlySubsForm__upload__button"
                  style="display: none"
                  ><input
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    ref="csvFileInput"
                    @change="uploadCSV"
                  />
                  Upload
                </label>
              </div>
              <p class="txt--xs txt--off-white text-center">
                (Upload CSV or Excel only)
              </p>

              <div class="file-preview-name my-2" v-if="csv_file">
                <span class="name">{{ csv_name }}</span>
                <span class="remove" @click="resetCSV()"
                  ><i class="fas fa-times"></i
                ></span>
              </div>

              <a
                href="Sample/SampleUserList.csv"
                download=""
                class="
                  txt--xs txt--off-white
                  text-center
                  d-flex
                  justify-content-center
                  mt-2
                "
                >Download Sample CSV
                <span class="ml-2"
                  ><i class="fas fa-cloud-download-alt"></i></span
              ></a>
            </div>
          </div>
        </div>

        <div class="session__modal__close" @click="closeModal()">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner
          class="button button--primary button--sm mr-3"
          @click="updateInvitation()"
          :disabled="upload.disabled"
          :loading="upload.loading"
          :success="upload.success"
        >
          Send</ButtonWithSpinner
        >
        <button type="button" class="button button--outline button--sm" @click="closeModal()">
          Cancel
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "InviteMorePermit",
  components: {
    VueTagsInput,
    ButtonWithSpinner,
  },
  data() {
    return {
      emailtag: "",
      emailtags: [],
      emailUploadProcess: "email",
      invitation_id: '',
      invitation_name: '',
      csv_file: null,
      csv_name: "",
      upload_button: {
        loading: false,
        success: false,
        disabled: false
      },
      upload: {
        loading: false,
        success: false,
        disabled: false
      },
      validation: [
        {
          classes: 'email-validation',
          rule: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
          disableAdd: true,
        }
      ]
    };
  },
  methods: {
    closeModal() {
      this.resetData();
      this.$modal.hide("invite-more-permit-modal");
    },
    getData(e) {
      this.resetData();
      this.invitation_id = e.params.invitation_id;
      this.invitation_name = e.params.invitation_name;
    },
    changeFilter(type) {
      if(this.emailUploadProcess != type) {
        this.emailUploadProcess = type;
        this.emailtag = "";
        this.emailtags = [];
        if(type == 'csv') {
          this.$nextTick(()=> {
            this.resetCSV(); 
          });
        }
        else {
          this.resetCSV();
        }
      }
    },
    resetData() {
      this.emailtag = "";
      this.emailtags = [];
      this.emailUploadProcess = "email";
      this.invitation_id = "";
      // this.invitation_name = "";
      // this.resetCSV();
    },
    uploadCSV(event) {
      this.upload_button.disabled = true;
      this.upload_button.loading = true;
      this.upload_button.success = false;

      let input = this.$refs.csvFileInput;

      let mimes = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel",
        "text/anytext",
        "csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "",
      ];

      if ( event.target.files.length > 0 && mimes.indexOf(event.target.files[0].type) != -1) {
        // 5 MB Validation
        if (event.target.files[0].size <= 5 * 1024 * 1024) {
          this.csv_name = event.target.files[0].name;
          this.csv_name = this.csv_name.split(".csv")[0];
          this.csv_file = event.target.files[0];
          
          this.upload_button.disabled = false;
          this.upload_button.loading = false;
          this.upload_button.success = true;

          setTimeout(()=> {
            this.upload_button.success = false;
          },2000);
        } else {

          this.$toasted.show("Max upload limit exceeded. Please upload a valid CSV/XLSX file!", {
            icon: "times-circle",
            className: "error-class",
          });

          this.resetCSV();
        }        
      } else {
        this.$toasted.show("Please upload a valid CSV file!", {
          icon: "times-circle",
          className: "error-class",
        });

        this.resetCSV();
      }
    },
    resetCSV() {
      let input = this.$refs.csvFileInput;
      input.type = "text";
      input.type = "file";
      this.csv_file = null;
      this.csv_name = "";
      this.upload_button.disabled = false;
      this.upload_button.loading = false;
      this.upload_button.success = false;
    },
    updateInvitation() {
      this.formData = new FormData();
      this.formData.append('invitation_id',this.invitation_id);
      let email = [];

      if(this.emailUploadProcess == 'email') {
        if(this.emailtags.length == 0) {
          this.$toasted.show("Please provide at least one email!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }

        email = this.emailtags.map((val)=> {return val.text});
        for(let i=0; i<email.length;i++) {
          this.formData.append(`email[${i}]`,email[i]);
        }
        this.formData.append("csv",null);
      }
      else {
        if(this.csv_file == null) {
          this.$toasted.show("Please upload a CSV/XLSX file!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }

        this.formData.append("email",[]);
        this.formData.append("csv",this.csv_file);
      }

      this.upload_button.disabled = true;
      this.upload_button.loading = true;

      this.upload.disabled = true;
      this.upload.loading = true;

      this.axios.post(window.hostname+'api/auth/invitation/add-more-emails',this.formData)
      .then(res=> {
        if(res.data.status) {
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          if(this.emailUploadProcess == 'csv') {
            this.resetCSV();
          }
          
          this.resetData();
          this.$emit('update_invitation_list');
          this.closeModal();
          this.upload_button.disabled = false;
          this.upload_button.loading = false;

          this.upload.disabled = false;
          this.upload.loading = false;
          this.upload.success = true;

          setTimeout(()=> {
            this.upload.success = false;
          },2000);
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
          this.upload_button.disabled = false;
          this.upload_button.loading = false;

          this.upload.disabled = false;
          this.upload.loading = false;
          return;
        }
      })
      .catch(err=> {
        console.log(err.response.data.message);

        this.$toasted.show("Server Error occured!",{
          icon: 'times-circle',
          className:'error-class'
        });

        this.upload_button.disabled = false;
        this.upload_button.loading = false;

        this.upload.disabled = false;
        this.upload.loading = false;
      })
    }
  },
};
</script>

<style>
</style>